import { createContext } from "react";

export type SlideOverSide = "left" | "right";

export const SlideOverContext = createContext<{
  open: boolean;
  setOpen: (open: boolean) => void;
  side: SlideOverSide;
  dismissible: boolean;
  isElastic: boolean;
  isDirectionLocked: boolean;
}>(null!);
